import { render, staticRenderFns } from "./sitestable.vue?vue&type=template&id=204fabc1"
import script from "./sitestable.vue?vue&type=script&lang=js"
export * from "./sitestable.vue?vue&type=script&lang=js"
import style0 from "./sitestable.vue?vue&type=style&index=0&id=204fabc1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports